<template>
  <div class="svg-wrapper">
    <svg version="1.1" id="video-graphic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="820px" height="874px" viewBox="0 0 820 874" enable-background="new 0 0 820 874" xml:space="preserve">
      <!-- <defs>
        <clipPath id="mask">
          <path fill-rule="evenodd" clip-rule="evenodd" fill="#fff" d="M782.872,834.705H517.169c-59.441,0-98.628-21.877-117.672-65.638
            l-87.396-201.986c-13.437-31.387-36.979-47.108-70.599-47.108H70.113L340.547,40.5h442.325V834.705z"/>
        </clipPath>
        <pattern id="home-bg" patternUnits="userSpaceOnUse" width="100" height="100">
          <image xlink:href="@/assets/home-bg.jpg" x="0" y="0" width="1920" height="1440" />
        </pattern>
      </defs> -->
      <!-- <path fill-rule="evenodd" clip-rule="evenodd" fill="#EF7816" d="M782.872,834.705H517.169c-59.441,0-98.628-21.877-117.672-65.638
        l-87.396-201.986c-13.437-31.387-36.979-47.108-70.599-47.108H70.113L340.547,40.5h442.325V834.705z"/> -->
      <path fill="#f1f1ee" opacity="0.3" d="M818.744,2v870H515.541c-94.18,0-134.921-48.192-152.513-88.616l-87.49-202.261
        C268.107,563.764,258.107,557,239.874,557H3.426L316.723,2H818.744 M820.744,0H315.556L0,559h239.874
        c17.527,0,26.695,6.254,33.826,22.91l87.492,202.268C378.995,825.087,420.226,874,515.541,874h305.203V0L820.744,0z"/>
      <!-- <foreignObject x="0" y="0" width="820px" height="874px">
        <video autoplay muted style="width: auto; height: 840px; -webkit-clip-path:url(#mask); clip-path:url(#mask); z-index: -1;">
          <source src="../assets/vid/home-vid.mp4" type="video/mp4">
        </video>
      </foreignObject> -->
      <!-- <image xlink:href="@/assets/home-bg.jpg" height="874" clip-path="url(#mask)"/> -->
      <path id="transparent-shape" opacity="0.1" fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M340.051,39.5h245.692
      C519.941,147.088,399.269,344.263,395.2,349.958c22.445,14.603,42.652,33.419,60.636,56.438
      c17.912,22.973,33.642,49.107,47.133,78.269l153.218,350.261H516.46c-59.554,0-98.814-21.889-117.895-65.671l-87.563-202.089
      c-13.461-31.403-37.049-47.133-70.732-47.133H68.558L339.61,40.127C339.755,39.915,339.905,39.711,340.051,39.5z"/>
    </svg>
    <!-- <svg version="1.1" id="video-graphic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="820px" height="874px" viewBox="0 0 820 874" enable-background="new 0 0 820 874" xml:space="preserve">
      <path id="transparent-shape" opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M340.051,39.5h245.692
        C519.941,147.088,399.269,344.263,395.2,349.958c22.445,14.603,42.652,33.419,60.636,56.438
        c17.912,22.973,33.642,49.107,47.133,78.269l153.218,350.261H516.46c-59.554,0-98.814-21.889-117.895-65.671l-87.563-202.089
        c-13.461-31.403-37.049-47.133-70.732-47.133H68.558L339.61,40.127C339.755,39.915,339.905,39.711,340.051,39.5z"/>
    </svg> -->
  </div>
</template>

<script>
export default {
  name: 'home-graphic'
}
</script>
